import React, { useEffect, useState } from 'react';
// import Datas from '../data/about-us/about-us2.json';
// import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/aboutUsTwo.js";

import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { PostApi } from '../services/CommonService2.js';
import Testrimonial from './testrimonial/Testrimonial.jsx';
import backbutton from '../politicalimgeas/back1.png'
import State from './States.js'
function AboutUsTwo() {
	const history = useHistory();
	const [eduData, setEduData] = useState([])
	const [eduTypes, setEduTypes] = useState([])
	const [tenantData, settenantData] = useState("");
	const [user, setUser] = useState(false)
	const [userdata, setUserdata] = useState()
	// const [edutypeId,setEdutypeId]=useState(null)

	useEffect(() => {
		getBtech()
	}, [])


	const getBtech = async () => {
		var edutypeId = null;
		var tntId = JSON.parse(localStorage.getItem('tID'))
		const sessiondetails = localStorage.getItem(`userdata${tntId}`);
		const localUserdata = JSON.parse(sessiondetails);

		if (sessiondetails != null) {
			setUser(true)
			const localUserdata = JSON.parse(sessiondetails);
			setUserdata(localUserdata?.user?.roles[0].name)
			if (localUserdata.user.studentedutype == "btech") {
				edutypeId = "1"
			} else if (localUserdata.user.studentedutype == "degree") {
				edutypeId = "2"
			} else if (localUserdata.user.studentedutype == "pg") {
				edutypeId = "3"
			}
		}
		settenantData(tntId)
		let reqparams = ''

		if (localUserdata?.user.subapplicationid && localUserdata != null) {
			reqparams = {
				pageno: '-1',
				query: {
					status: 'Active',
					area: {
						$elemMatch: { "value": localUserdata?.user?.subapplicationid }
					}
				},
			}

		}
		else {
			reqparams = {
				pageno: '-1',
				query: { status: 'Active' },
			}

		}



		const dataResponse = await PostApi(reqparams, 'EDUCATION');
		// console.log("The education response is", dataResponse?.data);
		// console.log("edutypeId", edutypeId);

		setEduData(dataResponse?.data)
		if (edutypeId == null) {
			if (sessiondetails != null) {
				const filterEdu = dataResponse?.data.filter(ele => ele.educationcode == "1")
				setEduData(filterEdu)
				if (localUserdata.user.roles[0].name == "DEMO_USER") {
					setEduData(dataResponse?.data)

				}
				// console.log("inside if", localUserdata.user.roles[0].name);

			} else {
				setEduData(dataResponse?.data)
			}
		} else {
			const filterEdu = dataResponse?.data.filter(ele => ele.educationcode == edutypeId)

			setEduData(filterEdu)
		}


		const reqparams2 = {
			pageno: '-1',
			query: { status: 'Active' }
		}
		const dataResponse1 = await PostApi(reqparams2, 'EDUCATIONTYPES');
		// console.log("about us Response", dataResponse1);

		setEduTypes(dataResponse1?.data)


	}


	const goBack = () => {
		history.goBack();
	};

	return (
		<Styles>

			{/* <div class="container goback">
					<a href="index.html"><img class="videologo " src={backbutton} alt="" /> </a>
				</div> */}
			{eduData.map((data, ind) => {
				let index = false
				if (user) {
					if (userdata != "DEMO_USER") {
						index = ind < 1
					} else {
						index = ind < 3
					}
				}
				else {
					index = ind < 3
				}
				return index && (<section className="plans-main-block College-Scholars" key={ind}>
					<button className="btn btn-warning" onClick={goBack} style={{ position: "fixed", bottom: "20px", left: "10px", zIndex: 999 }}><i class="fa-solid fa-arrow-left"></i></button>
					<div className="container py-3">
						<div className="row">
							<div class="content">
								<h1 className="fw-bold text-decoration-underline">{data.name}</h1>
								<p>{data.description.slice(0, 100)}</p>
							</div>
							<div className="clearfix"></div>

							<div className="cards">
								{eduTypes?.map((type, idx) => {
									if (type.educationid == data.id) {
										return <div className="card-container" key={idx}>
											<Link to={{
												pathname: "/stuprogram-grid",
												state: type
											}} ><div className="card">
													<div className='heading-card'>
														{type.name.split(" ")[0] != "Post" ? [<h3 > {type.name.split(" ")[0]}  </h3>, <h4 > {type.name.split(" ").map((ele, ind) => {
															if (ind > 0) {
																return ele
															}
														})} </h4>] : [<h3 > {type.name.split(" ")[0]} {type.name.split(" ")[1]} </h3>, <span > {type.name.split(" ").map((ele, ind) => {
															if (ind > 1) {
																return ele
															}
														})} </span>]}
													</div>

													<a href="Courses.html" class="learn-more">Learn More</a>


												</div>

											</Link>

										</div>

									}
								})}
								{data.educationcode < 3 && <div>
									<State educationcode={data.educationcode} />
								</div>}


							</div>
						</div>
					</div>
				</section>)

			})}
			<div className='mt-5 mb-5'>
				{tenantData == "526daf25" && <Testrimonial />}
			</div>
		</Styles>
	)
}

export default AboutUsTwo;